const mva_crtdlcnfdtf_096 = false;
document.addEventListener("DOMContentLoaded", async ()=>{
    GeneCrnd("L");
    const mva_gcsts = await mva_gtcrtf();
}, false);

document.querySelectorAll(".mva_kntch_prd_br_iif_cnt").forEach((mva_kpmfor) => {
  mva_kpmfor.addEventListener('click', (mvae) => {
    mva_rst_err();
    var act = mvae.target.getAttribute("data-mva_kpm_act");
    var mva_kpm_base = mvae.target.getAttribute("data-mva_kpm_for").replace("mva_kpmfor_","mva_kpmind_");
    var bv = parseInt(document.getElementById(mva_kpm_base).value);
    if(act === "m" && bv > 0){
        var bvalue = bv - 1;
        document.getElementById(mva_kpm_base).value = bvalue;
        document.getElementById(mva_kpm_base).setAttribute("data-mvkp_old",bvalue);
        if(bvalue === 0){
            var mf = mva_frming_int(document.getElementById(mva_kpm_base).getAttribute("data-mvvrint_prc"),bvalue,"rst");
        }else{
            var mf = mva_frming_int(document.getElementById(mva_kpm_base).getAttribute("data-mvvrint_prc"),bvalue,"ttl");
        };
        document.querySelector(".mva_kntch_prd_body_row:has(#" + mva_kpm_base + ") .mva_kntch_prd_br_info_prc").textContent = mf;
        mva_sb_ttl_prd();
    }else if(act === "p" && bv < 99){
        var bvalue = bv + 1;
        document.getElementById(mva_kpm_base).value = bvalue;
        document.getElementById(mva_kpm_base).setAttribute("data-mvkp_old",bvalue);
        if(bvalue === 0){
            var mf = mva_frming_int(document.getElementById(mva_kpm_base).getAttribute("data-mvvrint_prc"),bvalue,"rst");
        }else{
            var mf = mva_frming_int(document.getElementById(mva_kpm_base).getAttribute("data-mvvrint_prc"),bvalue,"ttl");
        };
        document.querySelector(".mva_kntch_prd_body_row:has(#" + mva_kpm_base + ") .mva_kntch_prd_br_info_prc").textContent = mf;
        mva_sb_ttl_prd();
    };
  });
});

document.getElementById("mva_kntp_shp_rdo_1").addEventListener('click', ()=>{document.querySelector(".mva_kntch_prd_btm_spndate").textContent = "・配送希望日：希望日なし（最短）";});
document.getElementById("mva_kntp_shp_rdo_2").addEventListener('click', ()=>{
    if(document.getElementById("Deli_date_crndr").className == "Deli_date_crndr_hid"){Focs_INP("cart_date_no_date");};
    var shp_dte = document.getElementById("cart_date_no_date").value;
    document.querySelector(".mva_kntch_prd_btm_spndate").textContent = "・配送希望日：" + shp_dte;
});
document.getElementById("cart_date_no_date").addEventListener("click",()=>{
    document.getElementById("mva_kntp_shp_rdo_2").checked = true;
    if(document.getElementById("Deli_date_crndr").className == "Deli_date_crndr_hid"){Focs_INP("cart_date_no_date");};
});

document.querySelectorAll(".mva_kntch_prd_br_iif_mdl").forEach((mva_kpm_value) => {
    mva_kpm_value.setAttribute("data-mvkp_old",mva_kpm_value.value);
    mva_kpm_value.addEventListener('input', (input_mvkp) => {
        mva_rst_err();
        if(/^\d*$/.test(input_mvkp.target.value) === true && input_mvkp.target.value != ""){
            if(parseInt(input_mvkp.target.value) < 100){
                input_mvkp.target.setAttribute("data-mvkp_old",parseInt(input_mvkp.target.value));
                input_mvkp.target.value = parseInt(input_mvkp.target.value);
                var mf = mva_frming_int(input_mvkp.target.getAttribute("data-mvvrint_prc"),input_mvkp.target.value,"ttl");
                document.querySelector(".mva_kntch_prd_body_row:has(#" + input_mvkp.target.getAttribute("id") + ") .mva_kntch_prd_br_info_prc").textContent = mf;
                mva_sb_ttl_prd();
            }else{
                input_mvkp.target.parentElement.querySelector(".mva_kntch_pci_err").setAttribute("data-pci_errdsp","true");
                input_mvkp.target.value = parseInt(input_mvkp.target.getAttribute("data-mvkp_old"));
                setTimeout(()=>{mva_rst_err()},2000);
            };
        }else if(input_mvkp.target.value === ""){
            input_mvkp.target.setAttribute("data-mvkp_old","0");
            input_mvkp.target.value = 0;
            var mf = mva_frming_int(input_mvkp.target.getAttribute("data-mvvrint_prc"),input_mvkp.target.value,"rst");
            document.querySelector(".mva_kntch_prd_body_row:has(#" + input_mvkp.target.getAttribute("id") + ") .mva_kntch_prd_br_info_prc").textContent = mf;
            mva_sb_ttl_prd();
        }else{
            input_mvkp.target.value = parseInt(input_mvkp.target.getAttribute("data-mvkp_old"));
        };
    });
});

document.querySelectorAll(".mva_kntch_prd_br_select").forEach((mva_kpm_select) => {
    mva_kpm_select.addEventListener('change', (change_mvkp) => {
        var prd_row = change_mvkp.target.selectedOptions[0].getAttribute("data-mvvrint_ford");
        var prd_prc = change_mvkp.target.selectedOptions[0].getAttribute("data-mvvrint_prc");
        document.querySelector('.mva_kntch_prd_body_row[data-mvakd_prd="' + prd_row + '"]').querySelector(".mva_kntch_prd_br_info_prc").textContent = prd_prc;
        mva_sb_ttl_prd();
    });
});

function mva_rst_err(){
    for(let mva_err of document.querySelectorAll(".mva_kntch_pci_err")){
        mva_err.setAttribute("data-pci_errdsp","false");
    };
};

function mva_frming_int(mva_prc_828,mva_int_828,mva_sts_828){
    if(mva_sts_828 === "ttl"){
        var frmed_base = mva_prc_828.split("：")[1].replace("¥","").replace(",","").replace("～","");
        var frmed = mva_int_828 + "セット：¥" + (parseInt(frmed_base) * parseInt(mva_int_828)).toLocaleString('ja-JP');
        return frmed;
    }else if(mva_sts_828 === "rst"){
        var frmed_base = mva_prc_828.split("：")[1].replace("～","") + "～";
        return frmed_base;
    }else if(mva_sts_828 === "fmt"){
        var frmed_base = mva_prc_828.split("：")[1].replace("¥","").replace(",","").replace("～","");
        var frmed = parseInt(frmed_base) * parseInt(mva_int_828);
        return frmed;
    };
};

function mva_sb_ttl_prd(){
    let htncf = document.querySelector(".mva_kntch_prd_body_ttl").getAttribute("data-htnspgvl").split(",");
    let pid_list = [];
    let ttv = 0;
    var mv_input = document.querySelectorAll(".mva_kntch_prd_br_ii_field input");
    for(var elm of mv_input){
        if(parseInt(elm.value) > 0){
            var elm_p = mva_frming_int(elm.getAttribute("data-mvvrint_prc"),elm.value,"fmt");
            var pid = elm.getAttribute("data-mvvrint_prnprdd");
            pid_list.push(pid);
            ttv = ttv + elm_p;
        };
    };
    var mv_select = document.querySelectorAll(".mva_kntch_prd_br_select");
    for(var elm of mv_select){
        if(parseInt(elm.value) > 0){
            var elm_p = mva_frming_int(elm.selectedOptions[0].getAttribute("data-mvvrint_prc"),"1","fmt");
            var pid = elm.selectedOptions[0].getAttribute("data-mvvrint_ford");
            document.querySelector(".mva_kntch_prd_body_row:has(#" + elm.getAttribute("id") + ") .mva_kntch_prd_br_info_prc").textContent = elm.selectedOptions[0].getAttribute("data-mvvrint_prc")
            pid_list.push(pid);
            ttv = ttv + elm_p;
        };
    };
    document.querySelector(".mva_kntch_prd_bf_ttl").textContent = "合計：¥" + ttv.toLocaleString('ja-JP');
    document.querySelector(".mva_kntch_prd_bottom").setAttribute("data-mvktc_btmdsp",ttv);
    if(pid_list.length == 1){
        if(String(pid_list[0]) == String(htncf[0]) ){
            var ttv_spg = ttv + 550;
            document.querySelector(".mva_kntch_prd_bf_ttl").textContent = "合計：¥" + ttv_spg.toLocaleString('ja-JP');
            document.querySelector(".mva_kntch_prd_bottom").setAttribute("data-mvktc_btmdsp",ttv_spg);
            var spgd = document.querySelector('.mva_kntch_prd_br_select:has(option[data-mvvrint_ford="' + pid_list[0] + '"])').getAttribute("id");
            var spbase = document.querySelector(".mva_kntch_prd_body_row:has(#" + spgd + ") .mva_kntch_prd_br_info_prc").textContent;
            document.querySelector(".mva_kntch_prd_body_row:has(#" + spgd + ") .mva_kntch_prd_br_info_prc").textContent = spbase.split("：")[0] + "：¥" + ttv_spg.toLocaleString('ja-JP');
        };
    };
};

function mva_chk_bf_ck(){
    let htncf = document.querySelector(".mva_kntch_prd_body_ttl").getAttribute("data-htnspgvl").split(",");
    let pid_list = [];
    var prd_list = [];
    var ptl = [];
    var mv_input = document.querySelectorAll(".mva_kntch_prd_br_ii_field input");
    for(var elm of mv_input){
        if(elm.value > 0){
            var pid = elm.getAttribute("data-mvvrint_prnprdd");
            pid_list.push(pid);
            var prnt = document.querySelector('.mva_kntch_prd_body_row:has(#' + elm.getAttribute("id") + ')');
            var pdct = {};
            var pt = {};
            pdct["ttl"] = prnt.querySelector(".mva_kntch_prd_br_info_ttl").textContent;
            pdct["prc"] = prnt.querySelector(".mva_kntch_prd_br_info_prc").textContent;
            pdct["img"] = prnt.querySelector(".mva_kntch_prd_br_image img").getAttribute("src");
            prd_list.push(pdct);
            pt['id'] = parseInt(elm.getAttribute("data-mvvrint_vrnd"));
            pt['quantity'] = parseInt(elm.value);
            ptl.push(pt);
        };
    };
    var mv_select = document.querySelectorAll(".mva_kntch_prd_br_select");
    for(var els of mv_select){
        if(els.value > 0){
            var pid = els.selectedOptions[0].getAttribute("data-mvvrint_ford");
            pid_list.push(pid);
            var prnt = document.querySelector('.mva_kntch_prd_body_row:has(#' + els.getAttribute("id") + ')');
            var pdct = {};
            var pt = {};
            pdct["ttl"] = prnt.querySelector(".mva_kntch_prd_br_info_ttl").textContent;
            pdct["prc"] = prnt.querySelector(".mva_kntch_prd_br_info_prc").textContent;
            pdct["img"] = prnt.querySelector(".mva_kntch_prd_br_image img").getAttribute("src");
            prd_list.push(pdct);
            pt['id'] = parseInt(els.value);
            pt['quantity'] = 1;
            ptl.push(pt);
        };
    };
    if(pid_list.length == 1){
        if(String(pid_list[0]) == String(htncf[0]) ){
            var pt = {};
            var ptl = [];
            var htwr = document.querySelector('.mva_kntch_prd_br_select:has(option[data-mvvrint_ford="' + pid_list[0] + '"])').selectedOptions[0].getAttribute("data-mvvrintsppd");
            pt['id'] = parseInt(htwr);
            pt['quantity'] = 1;
            ptl.push(pt);
        };
    };
    var exs_list = document.querySelectorAll(".mva_kntch_ord_rsl_list_row");
    for(var a = exs_list.length - 1;a >= 0;a--){
        exs_list[a].remove();
    };
    for(prd of prd_list){
        var row = document.createElement("div");
        row.setAttribute("class","mva_kntch_ord_rsl_list_row");
        var img = document.createElement("img");
        img.setAttribute("src",prd["img"]);
        var div_a = document.createElement("div");
        div_a.setAttribute("class","mva_kntch_ord_rlr_img");
        div_a.appendChild(img);
        var div_b = document.createElement("div");
        var div_c = document.createElement("div");
        var div_d = document.createElement("div");
        div_b.setAttribute("class","mva_kntch_ord_rlr_info");
        div_c.setAttribute("class","mva_kntch_ord_rlr_info_ttl");
        div_d.setAttribute("class","mva_kntch_ord_rlr_info_prc");
        div_c.textContent = prd["ttl"];
        div_d.textContent = prd["prc"];
        div_b.appendChild(div_c);
        div_b.appendChild(div_d);
        row.appendChild(img);
        row.appendChild(div_b);
        document.querySelector(".mva_kntch_ord_rsl_list").appendChild(row);
    };
    document.querySelector(".mva_kntch_ord_subg_shp").textContent = document.querySelector(".mva_kntch_prd_btm_spngflw").textContent;
    document.querySelector(".mva_kntch_ord_subg_dat").textContent = document.querySelector(".mva_kntch_prd_btm_spndate").textContent;
    document.querySelector(".mva_kntch_ord_subg_prc .mva_kntch_osp_vle").textContent = document.querySelector(".mva_kntch_prd_bf_ttl").textContent.replace("合計：","");
    var ptlstr = JSON.stringify(ptl).replace(/"/g, "'");
    document.querySelector(".mva_kntch_ord_rb_grid").setAttribute("data-mva_ptlvg_830",ptlstr);
};

function zth_al(hnb_kn) {
  var hnb_kn = hnb_kn.replace(/　/g,"").replace(/ /g,"");
  hnb_kn = hnb_kn.replace(/[０-９]/g, function(s) {
    return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
  });
  return hnb_kn.toUpperCase();
};
function kntch_chk_ukb_mva(hnb_kn_096){
    var pscc_uv = zth_al(hnb_kn_096);
    if(/^[0-9]+$/.test(pscc_uv) && pscc_uv.length === 9 && pscc_uv.slice(0,1) == "2"){
        document.getElementById("mvknt_ukb_829").value = pscc_uv;
        return true;
    }else{
        document.querySelector('.mva_kntch_inperr_dsc[data-kntch_inperr_value="ukb"]').setAttribute("data-kntch_inperr_dsp","true");
        return false;
    };
};
document.querySelector(".mva_kntch_prd_bf_button").addEventListener('click', () => {
    document.querySelector('.mva_kntch_inperr_dsc[data-kntch_inperr_value="ukb"]').setAttribute("data-kntch_inperr_dsp","false");
    document.querySelector('.mva_kntch_inperr_dsc[data-kntch_inperr_value="shp"]').setAttribute("data-kntch_inperr_dsp","false");
    var err_chk_096 = true;
    if(kntch_chk_ukb_mva(document.getElementById("mvknt_ukb_829").value) === false){
        document.querySelector('.mva_kntch_inperr_dsc[data-kntch_inperr_value="ukb"]').setAttribute("data-kntch_inperr_dsp","true");
        var err_chk_096 = false;
    };
    if(document.getElementById("mva_kntp_shp_rdo_2").checked){
        if(document.getElementById("cart_date_no_date").value == ""){
            document.querySelector('.mva_kntch_inperr_dsc[data-kntch_inperr_value="shp"]').setAttribute("data-kntch_inperr_dsp","true");
            var err_chk_096 = false;
        };
    };
    if(err_chk_096 == false){
        document.querySelector('.mva_kntch_inperr_dsc[data-kntch_inperr_dsp="true"]').scrollIntoView();
        window.scrollBy(0, -250);
        return;
    };
    var scr_y = window.scrollY;
    document.querySelector(".mva_kntch_ord_rslt").setAttribute("data-mvktc_rsldsp","true");
    mva_chk_bf_ck();
    document.querySelector("body").setAttribute("style","position:fixed;");
    document.querySelector(".mva_kntch_ord_rslt").setAttribute("data_mvk_scrh",scr_y);
});
document.getElementById("mva_kntch_bck_830").addEventListener('click', () => {
    document.querySelector("body").setAttribute("style","");
    window.scrollTo({top: parseInt(document.querySelector(".mva_kntch_ord_rslt").getAttribute("data_mvk_scrh") + "px")});
    document.querySelector(".mva_kntch_ord_rslt").setAttribute("data-mvktc_rsldsp","false");
});
document.getElementById("mva_kntch_ptcrt_830").addEventListener('click', async function(){
    document.querySelector(".mva_kntch_crtcnf_loading").setAttribute("data-crtcnf_load_dsp","true");
    var ptlstr = document.querySelector(".mva_kntch_ord_rb_grid").getAttribute("data-mva_ptlvg_830").replace(/'/g, '"');
    var prd_list = JSON.parse(ptlstr);
    const dlc_sts = await mva_dltcrtf();
    if(document.getElementById("mva_kntp_shp_rdo_2").checked){
        var shpdtv = document.getElementById("cart_date_no_date").value;
    }else{
        var shpdtv = "希望日なし（最短）";
    };
    var ukc = document.getElementById("mvknt_ukb_829").value;
    try {
        const addrsp = await fetch(window.Shopify.routes.root + 'cart/add.js',{
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({items: prd_list})
        });
        if (!addrsp.ok) {throw new Error('商品の追加に失敗しました');console.log("1");};
        const updrsp = await fetch(window.Shopify.routes.root + 'cart/update.js',{
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({attributes: {"受付番号": ukc,"配送希望日":shpdtv}})
        });
        if (!updrsp.ok) {throw new Error('カートの更新に失敗しました');console.log("1.5");};
        const crntrsp = await fetch(window.location.href, {
            method: 'GET',
            credentials: 'same-origin'
        }); 
        if (!crntrsp.ok) {throw new Error('ページの取得に失敗しました');console.log("2");}
        const crnt = await crntrsp.text();
        const d_prsr = new DOMParser();
        const doc = d_prsr.parseFromString(crnt, 'text/html');
        const crnt_mc = doc.querySelector('#mini-cart');
        if (!crnt_mc) {throw new Error('取得したページに#mini-cartがありません');console.log("3");}
        const ths_mc = document.querySelector('#mini-cart');
        if (!ths_mc) {throw new Error('現在のページに#mini-cartがありません');console.log("4")};
        ths_mc.replaceWith(crnt_mc);
        document.querySelector("#mini-cart .button.button--primary").click();
        document.querySelector(".mva_kntch_crtcnf_loading").setAttribute("data-crtcnf_load_dsp","false");
    }catch(error){
        console.error(error);
        alert('注文処理に失敗しました。もう一度お試しください。');
    };
});

function date_conf_N(){
  document.getElementById("Date_conf").className = "date_conf_cls_hid";
};

function date_conf_Y(){
  document.getElementById("cls_foot_Y").style = "background-color:#8fddeb";
  document.getElementById("checkout").click();
};

/*-_-_-_-_-_-_ date_crndr _-_-_-_-_-_-*/
function Reset_crnd_id(){
  /*document.getElementById("crnd_prev_id").className = "crnd_prev";*/
  document.getElementById("crnd_disp_id").className = "crnd_disp";
  /*document.getElementById("crnd_next_id").className = "crnd_next";*/
};

function GeneCrnd(Gene_Cnf){
  if(Gene_Cnf == "L"){
    /*var T_Date_Set = new Date();
    var T_year = T_Date_Set.getFullYear();
    var T_month = T_Date_Set.getMonth();*/
    var Curr_Day = new Date();
    var Curr_Day_value = Curr_Day.getFullYear() + "-" + ("00" + (Curr_Day.getMonth() + 1)).slice(-2) + "-" + ("00" + Curr_Day.getDate()).slice(-2);
    var Min_Day = new Date(Curr_Day_value);
    Min_Day.setDate(Min_Day.getDate() + 30);
    var T_year = Min_Day.getFullYear();
    var T_month = Min_Day.getMonth();
  }else if(Gene_Cnf == "P"){
    var T_year = parseInt(document.getElementById("Deli_date_crndr").getAttribute("data-SET_Y").split("+")[0]);
    var T_month = parseInt(document.getElementById("Deli_date_crndr").getAttribute("data-SET_M").split("+")[0]);
  }else if(Gene_Cnf == "N"){
    var T_year = parseInt(document.getElementById("Deli_date_crndr").getAttribute("data-SET_Y").split("+")[1]);
    var T_month = parseInt(document.getElementById("Deli_date_crndr").getAttribute("data-SET_M").split("+")[1]);
  };
  
  var Year_set = [];
  var Month_set = [];
  
  if(T_month == 0){
    Year_set = [T_year -1,T_year -1,T_year,T_year];
    Month_set = [11,11,0,1];
  }else if(T_month == 11){
    Year_set = [T_year,T_year,T_year,T_year + 1];
    Month_set = [10,10,11,0];
  }else{
    Year_set = [T_year,T_year,T_year,T_year];
    Month_set = [T_month - 1,T_month - 1,T_month,T_month + 1];
  };
  
  var Crnd_date_Arr = [];
  var C_Base_Date = new Date(Year_set[0], Month_set[0], 1).getDay() - 1;
  var C_date_Last = new Date(Year_set[0], Month_set[0], 0);
  for (var a = C_date_Last.getDate() - C_Base_Date; a <= C_date_Last.getDate(); a++) {
      Crnd_date_Arr.push(a);
  };
  for(var aa = 1;aa < 4; aa++){
    var C_date_First = new Date(Year_set[aa], Month_set[aa], 1);
    var C_date_Last = new Date(Year_set[aa], Month_set[aa] + 1, 0);
    if(aa == 2){var Abl_S = Crnd_date_Arr.length;};
    for (var a = C_date_First.getDate(); a <= C_date_Last.getDate(); a++) {
        Crnd_date_Arr.push(a);
    };
    if(aa == 2){var Abl_F = Crnd_date_Arr.length;};
  };
  var ad_arr =  106 - Crnd_date_Arr.length;
  for (var a = 1; a <= ad_arr; a++) {
      Crnd_date_Arr.push(a);
  };

  var Curr_Day = new Date();
  var Curr_Day_value = Curr_Day.getFullYear() + "-" + ("00" + (Curr_Day.getMonth() + 1)).slice(-2) + "-" + ("00" + Curr_Day.getDate()).slice(-2);
  var Min_Day = new Date(Curr_Day_value);
  Min_Day.setDate(Min_Day.getDate() + 10);
  var Min_Day_value = parseInt(Min_Day.getFullYear() + ("00" + (Min_Day.getMonth() + 1)).slice(-2) + ("00" + Min_Day.getDate()).slice(-2));
  
  for(var b = 0;b <= 104; b++){
    c = b + 1
    var Check_day = parseInt(Year_set[2] + ("00" + (Month_set[2] + 1)).slice(-2) + ("00" + Crnd_date_Arr[b]).slice(-2));
    document.getElementById("crnd_week_date_id_" + c).getElementsByClassName("crnd_td")[0].textContent = Crnd_date_Arr[b];
    document.getElementById("crnd_td_radio_id_" + c).checked = false;
    document.getElementById("crnd_td_radio_id_" + c).disabled = false;
    document.getElementById("crnd_week_date_id_" + c).style = "";
    if(b < Abl_S || b > Abl_F - 1){
      document.getElementById("crnd_week_date_id_" + c).style = "background-color:#ededed;";
      document.getElementById("crnd_week_date_id_" + c).getElementsByClassName("crnd_td")[0].textContent = "";
      document.getElementById("crnd_td_radio_id_" + c).disabled = true;
    };
    
    if(Min_Day_value > Check_day){
      document.getElementById("crnd_week_date_id_" + c).style = "background-color:#ededed;";
      document.getElementById("crnd_td_radio_id_" + c).disabled = true;
    };
  };
 
  document.getElementById("Deli_date_crndr").setAttribute("data-SET_Y",Year_set[1] + "+" + Year_set[3]);
  document.getElementById("Deli_date_crndr").setAttribute("data-SET_M",Month_set[1] + "+" + Month_set[3]);
  document.getElementById("deli_crnd_head_year").textContent = Year_set[2];
  document.getElementById("deli_crnd_head_month").textContent = Month_set[2] + 1;
};

function Crnd_btn_Prev(){
  /*document.getElementById("crnd_disp_id").className = "crnd_prev";*/
  document.getElementById("crnd_disp_id").className = "crnd_disp_hid";
  GeneCrnd("P");
  setTimeout(function(){ Reset_crnd_id(); },250);
};
function Crnd_btn_Next(){
  /*document.getElementById("crnd_disp_id").className = "crnd_prev";*/
  document.getElementById("crnd_disp_id").className = "crnd_disp_hid";
  GeneCrnd("N")
  setTimeout(function(){ Reset_crnd_id(); },250);
};
function Crnd_btn_Rst(){
  var Date_inp_id = document.getElementById("Deli_date_crndr").getAttribute("data-focs_date");
  document.getElementById(Date_inp_id).value = "";
};
document.querySelector('.deli_crnd_head_btn_R[data-chbr_btn="cls"]').addEventListener('click', (e)=>{
    if(document.getElementById("Deli_date_crndr").className == "Deli_date_crndr"){
        document.getElementById("Deli_date_crndr").className = "Deli_date_crndr_hid";
        e.stopPropagation();
        e.preventDefault();
    };
});

function Focs_INP(INP){
  document.getElementById("Deli_date_crndr").className = "Deli_date_crndr";
  document.getElementById("Deli_date_crndr").setAttribute("data-focs_date",INP);
  var crndr_elem = document.getElementById("Deli_date_crndr");
  var move_to = document.getElementById(INP.replace("_input",""));
  move_to.after(crndr_elem);
};

function SelecD(T_ele){
  var Crndr_date_value = document.getElementById(T_ele).getElementsByClassName("crnd_td")[0].textContent;
  if(Crndr_date_value != "" && document.getElementById(T_ele).getElementsByClassName("crnd_td_radio")[0].disabled != true){
    var Date_inp = document.getElementById("Deli_date_crndr").getAttribute("data-focs_date");
    var Crndr_date_Y = document.getElementById("deli_crnd_head_year").textContent;
    var Crndr_date_M = document.getElementById("deli_crnd_head_month").textContent;
    document.getElementById(Date_inp).value = Crndr_date_Y + "年" + Crndr_date_M + "月" + Crndr_date_value + "日";
    var shp_dte = document.getElementById("cart_date_no_date").value;
    document.querySelector(".mva_kntch_prd_btm_spndate").textContent = "・配送希望日：" + shp_dte;
  };
};

document.addEventListener('click', function(e){
  if(document.getElementById("Deli_date_crndr").className == "Deli_date_crndr"){
    if(!e.target.closest('.mva_kntch_prd_shplbl[for="mva_kntp_shp_rdo_2"]') && !e.target.closest("#Deli_date_crndr")) {
        document.getElementById("Deli_date_crndr").className = "Deli_date_crndr_hid";
    };
  };
});

async function mva_gtcrtf(){
    var vendor_list = [];
    var variant_list = [];
    try{const response = await fetch(window.Shopify.routes.root + 'cart.js');
        if (!response.ok) {throw new Error('カート情報の取得に失敗しました');};
        const cartData = await response.json();
        if(cartData.items.length === 0){
            document.querySelector(".mva_kntch_crtcnf_loading").setAttribute("data-crtcnf_load_dsp","false");
            return true;
        };
        for(var prd of cartData.items){
            if(prd["vendor"] == "サカイ引越センター_かんたん資材注文"){
                if(cartData["requires_shipping"]){
                    var cnfpath = "/collections/moving_accessory_kantan_chumon/mvngacce_827";
                }else{
                    var cnfpath = "/collections/moving_accessory_kantan_chumon/unnesship_827";
                };
                if(window.location.pathname != cnfpath){
                    window.location.href = cnfpath;
                    return true;
                };
                var vnd = {};
                vnd[prd["product_id"]] = {}
                vnd[prd["product_id"]]["vd"] = prd["variant_id"];
                vnd[prd["product_id"]]["qt"] = prd["quantity"];
                variant_list.push(vnd);
            }else{
                vendor_list.push(prd["vendor"]);
            };
        };
        if(vendor_list.length > 0){
            document.querySelector(".mva_kntch_crtcnf_dlg").setAttribute("data-crtcnf_dlg_dsp","true");
            return true;
        }else{
            const dlc_sts = await mva_dltcrtf();
            if(dlc_sts){
                for(vnd of variant_list){
                    var vk = Object.keys(vnd)[0];
                    var vk_doc = document.querySelector('.mva_kntch_prd_body_row[data-mvakd_prd="' + vk + '"]');
                    if(vk_doc.getAttribute("data-mvakd_inptypecnf906") == "true"){
                        vk_doc.querySelector(".mva_kntch_prd_br_select").value = vnd[vk]["vd"];
                    }else if(vk_doc.getAttribute("data-mvakd_inptypecnf906") == "false"){
                        vk_doc.querySelector(".mva_kntch_prd_br_iif_mdl").value = vnd[vk]["qt"];
                    };
                };
                if(variant_list.length > 0){mva_sb_ttl_prd()};
                await mva_upd_rsllst();
                document.querySelector(".mva_kntch_crtcnf_loading").setAttribute("data-crtcnf_load_dsp","false");
            };
        };
        return true;
    }catch(error){
        console.error(error);
        return false;
    };
};

async function mva_dltcrtf(){
    try {
        const response = await fetch(window.Shopify.routes.root + 'cart/clear.js',{method: 'POST',headers: {'Content-Type': 'application/json'}});
        if(!response.ok) {throw new Error('カートのクリアに失敗しました');}
        const cartData = await response.json();
        return true;
    }catch(error) {
        console.error(error);
        return false;
    };
};

async function mva_upd_rsllst() {
    const url = new URL(window.location.origin + window.location.pathname);
    try {
        const response = await fetch(url, {credentials: "same-origin",headers: {"Accept": "text/html"}});
        if (!response.ok) {throw new Error(`HTTP Error: ${response.status}`);};
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, "text/html");
        var src_dc = ".header__action-item.header__action-item--cart"
        const newProducts = doc.querySelector(src_dc);
        const currentProducts = document.querySelector(src_dc);
        if (!newProducts || !currentProducts) {return;};
        currentProducts.replaceWith(newProducts);
    }catch(error) {
        console.error(error);
        return false;
    };
};

document.getElementById("mva_kntch_db_start_order").addEventListener('click', ()=>{
    document.querySelector(".mva_kntch_crtcnf_dlg").setAttribute("data-crtcnf_dlg_dsp","false");
    document.querySelector(".mva_kntch_crtcnf_loading").setAttribute("data-crtcnf_load_dsp","false");
});
document.getElementById("mva_kntch_db_back_to_top").addEventListener('click', ()=>{
    document.querySelector(".mva_kntch_crtcnf_dlg").setAttribute("data-crtcnf_dlg_dsp","false");
    window.location.href = "/";
});